import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.restoreDirectory.alertTitle, 'Alert'),
  cancel: () => __(translations.restoreDirectory.cancel, 'Cancel'),
  yesImSure: () => __(translations.restoreDirectory.yesImSure, "Yes, I'm sure"),
  restoreMessage: () => __(translations.restoreDirectory.restoreMessage, 'Are you sure you want to restore this directory?'),
};
